define([
	"./_TextAlign",
	"./PluginFactory"
], function(_TextAlign,PluginFactory) {

	return PluginFactory.declare(_TextAlign, {
		"class": "csi-button-toggle csi-toggle-group-first",
		cssValue: "left",
		materialIcon: "format_align_left",
		pluginName: "textLeft",
		title: "CanvasLeftAlignText"
	});
});
